import '../../style/base.css';
import '../../loading/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/switch/style/index.js
// module id = 182
// module chunks = 31